/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Verification_NeededInputs */

const en_nfp_verification_needed = /** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action Required: Verification Document`)
};

const es_nfp_verification_needed = /** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción Requerida: Documento de Verificación`)
};

const fr_nfp_verification_needed = /** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action requise : Document de vérification`)
};

const de_nfp_verification_needed = /** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maßnahme erforderlich: Verifizierungsdokument`)
};

const id_nfp_verification_needed = /** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan Diperlukan: Dokumen Verifikasi`)
};

/** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */
const ja_nfp_verification_needed = en_nfp_verification_needed;

/** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */
const zh_nfp_verification_needed = en_nfp_verification_needed;

/** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */
const ar_nfp_verification_needed = en_nfp_verification_needed;

/** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */
const it_nfp_verification_needed = en_nfp_verification_needed;

/** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */
const ru_nfp_verification_needed = en_nfp_verification_needed;

/** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */
const pt_nfp_verification_needed = en_nfp_verification_needed;

/** @type {(inputs: Nfp_Verification_NeededInputs) => LocalizedString} */
const ko_nfp_verification_needed = en_nfp_verification_needed;

/**
* | output |
* | --- |
* | "Action Required: Verification Document" |
*
* @param {Nfp_Verification_NeededInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_verification_needed = /** @type {((inputs?: Nfp_Verification_NeededInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Verification_NeededInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_verification_needed(inputs)
	if (locale === "es") return es_nfp_verification_needed(inputs)
	if (locale === "fr") return fr_nfp_verification_needed(inputs)
	if (locale === "de") return de_nfp_verification_needed(inputs)
	if (locale === "ja") return ja_nfp_verification_needed(inputs)
	if (locale === "zh") return zh_nfp_verification_needed(inputs)
	if (locale === "ar") return ar_nfp_verification_needed(inputs)
	if (locale === "id") return id_nfp_verification_needed(inputs)
	if (locale === "it") return it_nfp_verification_needed(inputs)
	if (locale === "ru") return ru_nfp_verification_needed(inputs)
	if (locale === "pt") return pt_nfp_verification_needed(inputs)
	return ko_nfp_verification_needed(inputs)
});